export const formatLocalTime = (date, timeFormat12hrs) => {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    let suffix = '';

    if (timeFormat12hrs) {
        suffix = hours >= 12 ? ' PM' : ' AM';
        hours = hours % 12 || 12;
    }

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}${suffix}`;
}



export const parseToGlobalDate = (currentGuest) => {
    if(!currentGuest){
        return;
    }

    let parsedCurrentGuest = {...currentGuest}
    if(parsedCurrentGuest.plannedCheckOutDate?.includes("Z")){
        parsedCurrentGuest.plannedCheckOutDate = parsedCurrentGuest.plannedCheckOutDate.replace("Z", "");
    }

    if(parsedCurrentGuest.checkInDate?.includes("Z")){
        parsedCurrentGuest.checkInDate = parsedCurrentGuest.checkInDate.replace("Z", "");
    }

    return parsedCurrentGuest;
}
